import React from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';

function FreeEstimate() {
  return (
    <div className="min-h-screen bg-[#f7f8fa]">
      <Header />
      <Request />
      <Footer />
    </div>
  );
}

export default FreeEstimate;
